import React, { useEffect, useRef } from 'react';
var SnippylyPresence = function (props) {
    var maxUsers = props.maxUsers, inactivityTime = props.inactivityTime, documentParams = props.documentParams, location = props.location, self = props.self, onPresenceUserClick = props.onPresenceUserClick, onUsersChanged = props.onUsersChanged, onPresenceUserChange = props.onPresenceUserChange, disableFlockNavigation = props.disableFlockNavigation, defaultFlockNavigation = props.defaultFlockNavigation, onNavigate = props.onNavigate, flockMode = props.flockMode;
    var ref = useRef();
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onPresenceUserChange', function (event) {
                if (onUsersChanged) {
                    onUsersChanged(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onPresenceUserChange) {
                    onPresenceUserChange(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('navigate', function (event) {
                if (onNavigate) {
                    onNavigate(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onPresenceUserClick', function (event) {
                if (onPresenceUserClick) {
                    onPresenceUserClick(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-presence", { ref: ref, "flock-mode": [true, false].includes(flockMode) ? (flockMode ? 'true' : 'false') : undefined, "max-users": maxUsers, "inactivity-time": inactivityTime, "document-params": (typeof documentParams === 'object') ? JSON.stringify(documentParams) : (documentParams ? documentParams : undefined), "disable-flock-navigation": [true, false].includes(disableFlockNavigation) ? (disableFlockNavigation ? 'true' : 'false') : undefined, "default-flock-navigation": [true, false].includes(defaultFlockNavigation) ? (defaultFlockNavigation ? 'true' : 'false') : undefined, self: [true, false].includes(self) ? (self ? 'true' : 'false') : undefined, location: (typeof location === 'object') ? JSON.stringify(location) : (location ? location : undefined) }));
};
export default SnippylyPresence;
